<template>
    <div id="mainAdminApp" style="height: 100%; position: relative; overflow: hidden;">
        <div id="main-admin-container">
            <VirtualKeyboard></VirtualKeyboard>
            <div class="main-content">
                <div class="left-content">
                    <AdminModels v-if="!isParentOrigin" @dispose3DViewer="dispose3DViewer()" @launch-viewer="launchViewer3D"></AdminModels>
                    <AdminPointClouds v-if="!isParentOrigin" :assetid="assetId" :pointclouds="pointclouds" @update_pointclouds="updatePointClouds"></AdminPointClouds>
                    <AdminSettings v-if="!isParentOrigin" :assetid="assetId" :selectedgpssystem="selectedGPSSystem"></AdminSettings>
                    <AdminLevels v-if="!isParentOrigin" :assetid="assetId" :levels="levels" @update_levels="onUpdateLevels" @toggle-level-in-3d="toggleLevelIn3D" @launch-viewer="launchViewer2D"></AdminLevels>
                    <AdminProjects v-if="!isParentOrigin" :assetid="assetId" :projects="projects" @update_projects="onUpdateProjects"></AdminProjects>
                    <AdminCategories v-if="!isParentOrigin" @update_category="updateCategoryHandler" @delete_category="onDeleteCategory" :assetid="assetId"></AdminCategories>
                    <AdminStamps id="admin-stamps-section"></AdminStamps>
                    <AdminSymbols id="admin-symbols-section"></AdminSymbols>
                    <AdminAutomaticTags v-if="!isParentOrigin" @open_3d_viewer="open3dViewerIfNot"></AdminAutomaticTags>
                    <AmisSetup v-if="!isParentOrigin"></AmisSetup>
                    <AdminGeneralSettings v-if="!isParentOrigin && isAdmin && forgeSettings"></AdminGeneralSettings>

                    <AddAutomaticTagsPopup></AddAutomaticTagsPopup>
                    <PopulateAutomaticTagsPopup v-if="showPopulateAutomaticTagsPopup"></PopulateAutomaticTagsPopup>
                    <SyncAMISPopup v-if="isAMIS"></SyncAMISPopup>
                </div>
                <div class="right-content" v-if="shownModel || shownLevel2D">
                    <div class="model-info-section" v-if="shownModel && shownModel.urn">
                        <div class="model-info" v-if="shownModel.urn">
                            <div>
                                <span class="property-title">Model Name: </span>
                                <span class="property-value" :title="shownModel.name">
                                    {{ shownModel.name }} ({{
									shownModel.version
                                    }})
                                </span>
                            </div>
                            <div style="display:flex;column-gap:20px;">
                                <div class="property-wrapper">
                                    <span class="property-title">Uploaded By: </span>
                                    <span class="property-value" :title="shownModel.createdBy">{{ shownModel.createdBy }}</span>
                                </div>
                                <div class="property-wrapper">
                                    <span class="property-title">On: </span>
                                    <span class="property-value" :title="createdOn">{{ createdOn }}</span>
                                </div>
                                <div class="property-wrapper">
                                    <span class="property-title">Size: </span>
                                    <span class="property-value" :title="modelSize">{{ modelSize }}</span>
                                </div>
                                <div class="property-wrapper">
                                    <span class="property-title">Original File Ext: </span>
                                    <span class="property-value" :title="originalModelExt">{{ originalModelExt }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="top-right-btn" @click="dispose3DViewer()" title="Close">X</div>
                    </div>
                    <div class="admin-viewer" id="admin-forge-viewer" v-if="shownModel && shownModel.urn"></div>

                    <div class="upload-section" v-if="shownLevel2D && shownLevel2D.planUrn">

                        <div class="top-points-above-plan" v-if="shownLevel2D && shownModel">
                            <div id="first-point-button" :class="['admin-btn', isPoint1Valid ? '' : 'admin-btn-secondary']"
                                 @click="clickOnP1()">
                                Point(1)
                                <span>Click on the first same position on both 2D/3D Forge viewers</span>
                            </div>
                            <div id="second-point-button" :class="['admin-btn', isPoint2Valid ? '' : 'admin-btn-secondary']"
                                 @click="clickOnP2()">
                                Point(2)
                                <span>Click on the second same position on both 2D/3D Forge viewers</span>
                            </div>
                        </div>

                        <div class="info-section" v-if="shownLevel2D.planUrn">
                            <div>Model Name: {{ shownLevel2D.name }}</div>
                        </div>
                        <div class="top-right-btn" @click="dispose2DViewer()" title="Close">X</div>
                    </div>
                    <div class="admin-viewer" id="admin-forge-viewer2d" v-if="shownLevel2D && shownLevel2D.planUrn"></div>
                </div>
                <!-- <markups-popup></markups-popup> -->
            </div>
            <FillTagsImagesPopup></FillTagsImagesPopup>
            <AdminComboSymbolsUpload ref="admin-combo-symbols-upload"></AdminComboSymbolsUpload>
            <AdminSymbolsUpload ref="admin-symbols-upload"></AdminSymbolsUpload>
            <AdminStampsUpload ref="admin-stamps-upload"></AdminStampsUpload>
            <SuccessfulPopup v-if="localSuccessMessage" :message="localSuccessMessage"></SuccessfulPopup>
            <AdminUploadImagesPopup :projects="projects"></AdminUploadImagesPopup>
            <UpdateCategoryPopup :category_to_update="updateCategory" :assetid="assetId" @add_new_category="addNewCategory" @update_category="onUpdateCategory"></UpdateCategoryPopup>
            <EditShareFilePopup v-if="forgeSettings" @on-save="editShareFileLocation"></EditShareFilePopup>
            <EditLevel></EditLevel>
            <UploadModel :assetId="assetId" @disposeViewer="disposeViewer()" @launch-viewer="launchViewer3D"></UploadModel>
            <MessagePopup></MessagePopup>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import { dispose3DViewer, dispose2DViewer } from '@/scripts/js/forgeviewer'
import { ForgeSettings, ForgeLevel, ForgeProject, GPSSettings } from '@/scripts/js/forgeModels'
import { objectToQueryParams, getAllTagsForModelByAssetId } from '@/scripts/js/forgeService'
import { getAllLeafComponents, getMiddleBBoxForGroup, getForgeToken } from '@/utils/forgeUtils'
import { GET_ALL_DOCUMENTS } from '@/utils/attachmentsAPI'
import { saveLevels, editType } from '@/utils/mongoUtils'
import { getAMISToken } from '@/utils/amisAPIs'
import HttpService from '@/utils/httpService'

import VirtualKeyboard from '@/components/virtual-keyboard/virtual-keyboard.vue'
import AdminModels from '@/components/admin/components/adminModels.vue'
import MessagePopup from '@/components/common/messagePopup.vue'
import UploadModel from '@/components/admin/popups/uploadModels.vue'
import AdminPointClouds from '@/components/admin/components/adminPointclouds.vue'
import AdminSettings from '@/components/admin/components/adminSettings.vue';
import AdminProjects from '@/components/admin/components/adminProjects.vue';
import AdminLevels from '@/components/admin/components/adminLevels.vue';
import AdminCategories from '@/components/admin/components/adminCategories.vue';
import AdminStamps from '@/components/admin/components/stamps/adminStamps.vue';
import AdminSymbols from '@/components/admin/components/symbols/adminSymbols.vue';
import AdminAutomaticTags from '@/components/admin/components/automaticTags.vue';
import AdminGeneralSettings from '@/components/admin/components/adminGeneralSettings.vue';
import AddAutomaticTagsPopup from '@/components/admin/popups/addAutomaticTagsPopup.vue';
import PopulateAutomaticTagsPopup from '@/components/admin/popups/populateAutomaticTagsPopup.vue';
import AmisSetup from '@/components/admin/components/A-MIS/amisSetup.vue'
import SyncAMISPopup from '@/components/admin/components/A-MIS/syncAMISPopup.vue'
import EditLevel from '@/components/admin/popups/editLevel.vue'
import EditShareFilePopup from '@/components/shareFile/popups/shareFileEditPopup.vue'
import UpdateCategoryPopup from '@/components/admin/popups/updateCategory.vue'
import AdminUploadImagesPopup from '@/components/admin/popups/uploadImages.vue'
import SuccessfulPopup from '@/components/common/successfulPopup.vue'
import AdminStampsUpload from '@/components/admin/components/stamps/adminStampsUpload.vue'
import AdminSymbolsUpload from '@/components/admin/components/symbols/adminSymbolsUpload.vue'
import AdminComboSymbolsUpload from '@/components/admin/components/symbols/adminComboSymbolsUpload.vue'
import FillTagsImagesPopup from '@/components/admin/popups/fillTagsImagesPopup.vue'

export default {
	name: 'AdminView',
	components: {
		VirtualKeyboard,
		AdminModels,
		MessagePopup,
		UploadModel,
		AdminPointClouds,
		AdminSettings,
		AdminProjects,
		AdminLevels,
		AdminCategories,
		AdminStamps,
		AdminSymbols,
		AdminAutomaticTags,
		AdminGeneralSettings,
		AmisSetup,
		AddAutomaticTagsPopup,
		PopulateAutomaticTagsPopup,
		SyncAMISPopup,
		EditLevel,
		EditShareFilePopup,
		UpdateCategoryPopup,
		AdminUploadImagesPopup,
		SuccessfulPopup,
		AdminStampsUpload,
		AdminSymbolsUpload,
		AdminComboSymbolsUpload,
		FillTagsImagesPopup
	},
	data() {
		return {
			shownModel: null,
			shownLevel2D: null,
			pointclouds: [],
			selectedGPSSystem: this.$store.state.forgeService.gpsSystems[0],
			isPoint1Valid: false,
			isPoint2Valid: false,
			updateCategory: null,
			modelSize: "-",
			originalModelExt: "-",
		}
	},
	mounted() {
		this.$store.state.adminAppContainer = this;
		this.$store.state.forgeService.getForgeModels(this.assetId, data => {
			let forgeSettings = null;
			if (data != null) {
				if (data.models) {
					data.models.forEach(o => o.isMainVersion = o.name == data.selectedModel);
					this.$store.state.uploadedModels = data.models;
				}
				this.pointclouds = data.pointCloudModels;
				forgeSettings = Object.assign(new ForgeSettings(), data.settings);
				if (!forgeSettings.inspectionFiltersColors)
					forgeSettings.inspectionFiltersColors = (new ForgeSettings()).inspectionFiltersColors;
				let levels = ForgeLevel.parseLevelsFromDB(data.levels);
				this.$store.commit('setLevels', levels)
				let projects = ForgeProject.parseProjectsFromDB(data.projects);
				this.$store.commit('setProjects', projects)

				if (data.categories && data.categories.length > 0) {
					this.$store.state.categories = data.categories;
				}

				var selectedLevel = levels.find(o => o.name == data.selectedLevel);
				if (selectedLevel)
					selectedLevel.isSelected = true;

				if (data.shareFileParentId)
					this.$store.state.shareFileParentId = data.shareFileParentId;

			} else {
				forgeSettings = new ForgeSettings();
			}

			if (!forgeSettings)
				forgeSettings = new ForgeSettings();
			//gps settings
			if (!forgeSettings.gpsSettings)
				forgeSettings.gpsSettings = new GPSSettings();
			forgeSettings.gpsSettings = Object.assign(new GPSSettings(), forgeSettings.gpsSettings)

			this.$store.state.forgeSettings = forgeSettings;

			if (forgeSettings.ignoredDbIds) {
				let ignoredDbIds = forgeSettings.ignoredDbIds.split(',').map(Number);
				this.$store.commit('SET_IGNORED_TAGS_IDS', new Uint32Array(ignoredDbIds));
			}

			this.$store.dispatch('LOAD_AMIS_COLORS');
		});

		GET_ALL_DOCUMENTS(objectToQueryParams({ assetId: this.assetId })).catch(error => {
			console.error('Get All Documents -> ' + error.message);
		});
	},
	methods: {
		open3dViewerIfNot() {
			let currentModel = this.$store.state.uploadedModels.find(o => o.isMainVersion)
			if (!currentModel) {
				this.$store.dispatch({ type: "alert_Forge", message: 'No model 3d found, please upload and select a 3d model first.' })
				return false;
			}
			if (this.viewer && currentModel.urn == this.$store.state.currentUrn)
				return true;
			this.launchViewer3D(currentModel)
			return true;
		},
		editShareFileLocation(id) {
			this.$store.state.forgeSettings.shareFileParentId = id;

			HttpService({
				url: 'api/forge/settings/updateAssetShareFileParent',
				data: { assetId: this.$store.state.assetId, shareFileParentId: id },
			}).catch(error => {
				console.log(error);
			});
		},
		launchViewer3D(model, isModelUpload) {
			this.dispose3DViewer();
			this.modelSize = "-";
			this.originalModelExt = "-";
			this.shownModel = model;
			this.launchViewer_Admin(model.urn, 'admin-forge-viewer', viewer0 => {
				this.viewer = viewer0;
				this.originalModelExt = this.viewer.model.getDocumentNode()?.name()?.split('.')?.pop() ?? "-";

				if (this.viewer && !!model.displayUnit) {
					let displayUnit = this.viewer.model.getUnitString();

					model.displayUnit = displayUnit;

					this.$store.dispatch({
						type: "updateDisplayUnit",
						displayUnit: displayUnit
					})
				}

				this.$store.state.globalOffset = this.viewer.model.getGlobalOffset();
				this.$store.state.unitScale = this.viewer.model.getUnitScale();
				this.viewer.loadExtension('Mapping2d_3dExtension');

				this.viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, _ => {
					this.modelSize = `${(this.viewer.model.getGeometryList().geomMemory / (1024 * 1024)).toFixed(2)} Mb`;
					this.$store.state.isGeometryLoaded = true;

					var geometryLoadedCallback = this.$store.getters.GET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK;

					if (geometryLoadedCallback) {
						geometryLoadedCallback();
						this.$store.commit("SET_ADMIN_MODEL_GEOMETRY_LOADED_CALLBACK", null);
					}

					if (this.forgeService.tagToZoomToIn3D) {
						setTimeout(() => {
							this.forgeService.zoomInAllAvailableViewers(this.forgeService.tagToZoomToIn3D, true);
							this.forgeService.tagToZoomToIn3D = null;
						}, 0);
					}
				})

				this.viewer.addEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, () => {
					if(isModelUpload){
						this.forgeService.getAllTagsForModelByAssetId(this.$store.state.assetId).then(tags => {
							this.updateModelTags(tags);
						});
					}

					let oldDbids = this.$store.state.levels.map(o => o.dbidsList)
					this.forgeService.fillLevelsDbids(this.viewer)

					//save dbids if were not the same what is existing
					for (let i = 0; i < this.$store.state.levels.length; i++) {
						let level = this.$store.state.levels[i]
						if (!oldDbids[i] || oldDbids[i].length != level.dbidsList.length) {
							saveLevels(level, editType.EDIT_LEVEL);
						}
					}
					this.$store.commit("setIsTreeLoaded", true);
					//fill properties
					this.$store.dispatch('fillAllModelProperties', { viewer: this.viewer });

					// //fill forgeService.allForgeElements for if user wants to pick objects to re-assign to amis tag
					// getAllLeafComponents(this.viewer.model, (dbIds) => {
					// 	this.forgeService.allForgeElements = [];
					// 	for (var i = 0; i < dbIds.length; i++) {
					// 		let elem = this.forgeService.dbidToForgeObject(dbIds[i], this.viewer.model);
					// 		this.forgeService.allForgeElements.push(elem);
					// 	}
					// });
				});
				this.viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, () => {
					let callback = this.$store.getters.GET_ON_SELECTION_CHANGED_CALLBACK;

					if (!callback) return

					let selection = this.viewer.getSelection();

					if (selection.length == 0) return

					let obj = this.forgeService.dbidToForgeObject(selection[0], this.viewer.model);

					if (!obj) return;

					let point = this.forgeService.view3dToWorld(getMiddleBBoxForGroup(selection, this.viewer.model).getCenter());

					callback(obj, point, selection);
				});


				this.forgeService.initializeMappingPointsEvents(this.viewer, true);

				this.resizeViewers();
			});
		},
		launchViewer2D(level) {
			this.dispose2DViewer();
			this.shownLevel2D = level;
			this.forgeService.mappedPoint1 = { generalViewPoint: null, planViewPoint: null };
			this.forgeService.mappedPoint2 = { generalViewPoint: null, planViewPoint: null };
			this.isPoint1Valid = false;
			this.isPoint2Valid = false;
			this.$store.state.selectedLevel = level;
			this.launchViewer_Admin(level.planUrn, 'admin-forge-viewer2d', viewer0 => {
				this.$store.state.planViewer = viewer0;
				this.forgeService.initializeMappingPointsEvents(this.$store.state.planViewer, false);
			});
			this.resizeViewers();
		},
		toggleLevelIn3D(level) {
			level.isShowingIn3D = !level.isShowingIn3D
			if (this.viewer && this.viewer.getExtension('Mapping2d_3dExtension')) {
				this.forgeService.getMappingExtension3D().updateShownLevels();
			}
			else {
				let targetModel = this.$store.state.uploadedModels.find(o => o.isMainVersion && o.isMainVersion)
				if (targetModel)
					this.launchViewer3D(targetModel);
				else {
					this.$store.dispatch({ type: "alert_Forge", message: 'Please upload 3d model first.' })
					return;
				}
			}
			this.$store.state.selectedLevel = level;

		},
		updateModelTags(tags){
			if(tags.length > 0){
				var instanceTree = this.viewer.model.getInstanceTree();

				tags.forEach(item => {
					var dbIds = instanceTree.search(item.name);
					item.dbId = dbIds[0];
				});
				
				HttpService.patch({
					url: `api/baseTags/updateTagDbIds`,
					data: tags,
				}).then(() => {
					this.$store.dispatch({
						type: 'showSuccessfulMessage',
						message: "Tags updated successfully.",
						timeout: 3000
					});
					this.$store.state.viewer.isolate(tags.map(item => item.dbId))
				}).catch(() => {
					this.$store.dispatch({
						type: "alert_Forge",
						message: "Tag update failed. Please update tags using Tag Harvester."
					});
				});
			}
		},
		resizeViewers() {
			setTimeout(() => {
				if (this.viewer)
					this.viewer.resize();
				if (this.$store.state.planViewer)
					this.$store.state.planViewer.resize();
			}, 100);
		},
		launchViewer_Admin(urn, containerId, callback) {
			this.$store.state.currentUrn = urn;
			var options = {
				// env: 'AutodeskProduction',
				env: 'AutodeskProduction2',
				api: 'streamingV2', //or streamingV2_EU if in EMEA region
				getAccessToken: getForgeToken,
			};
			let viewer0 = null;
			Autodesk.Viewing.Initializer(options, () => {
				let container = document.getElementById(containerId);
				viewer0 = new Autodesk.Viewing.GuiViewer3D(container);
				viewer0.start();
				var documentId = 'urn:' + urn;
				Autodesk.Viewing.Document.load(documentId, (doc) => {
					var viewables = doc.getRoot().getDefaultGeometry();
					viewer0.loadDocumentNode(doc, viewables).then(i => {
						viewer0.navigation.setReverseZoomDirection(true);
						callback(viewer0);
					});
				}, this.onDocumentLoadFailure);
			});
		},
		onDocumentLoadFailure(viewerErrorCode) {
			console.error('onDocumentLoadFailure() - errorCode:' + viewerErrorCode);
		},
		disposeViewer() {
			this.dispose3DViewer();
			this.dispose2DViewer();
			Autodesk.Viewing.shutdown();
		},
		dispose3DViewer() {
			dispose3DViewer();
			this.$store.state.isGeometryLoaded = false;
			this.$store.commit("setIsTreeLoaded", false);
			this.shownModel = null;
			this.resizeViewers();
		},
		dispose2DViewer() {
			dispose2DViewer();
			this.shownLevel2D = null;
			this.resizeViewers();
		},
		clickOnP1() {
			this.forgeService.mappedPoint1 = { generalViewPoint: null, planViewPoint: null };
			this.forgeService.isPickingMappingPoint1 = true;
			this.forgeService.isPickingMappingPoint2 = false;
			this.isPoint1Valid = false;
		},
		clickOnP2() {
			this.forgeService.mappedPoint2 = { generalViewPoint: null, planViewPoint: null };

			this.forgeService.isPickingMappingPoint2 = true;
			this.forgeService.isPickingMappingPoint1 = false;
			this.isPoint2Valid = false;
		},
		updateCategoryHandler(category) {
			this.updateCategory = { ...category }
		},
		addNewCategory(category) {
			var nameExist = this.categories.some(c => c.name == category.name);

			if (nameExist) {
				this.$store.dispatch({
					type: "alert_Forge",
					message: 'Category Name Already Exist'
				})

				return
			}

			this.addNewCategoryAPI(category, newCategory => {
				this.$store.state.categories.push(newCategory);
			});
		},
		onUpdateCategory(category) {
			var nameExist = this.categories.some(c => c.name == category.name && c.id != category.id);

			if (nameExist) {
				this.$store.dispatch({
					type: "alert_Forge",
					message: 'Category Name Already Exist'
				})

				return
			}

			this.updateCategoryAPI(category, newCategory => {
				var foundIndex = this.categories.findIndex(x => x.id == newCategory.id);
				let temp = this.categories
				temp[foundIndex] = newCategory;
				this.$store.state.categories = [...temp]
			});
		},
		onDeleteCategory(category) {
			this.deleteCategoryAPI(category.id, response => {
				var foundIndex = this.categories.findIndex(x => x.id == category.id);
				let temp = this.categories
				temp.splice(foundIndex, 1);
				this.$store.state.categories = [...temp]
			});
		},
		addNewCategoryAPI(category, callback) {
			HttpService.post({
				url: 'api/forge/categories/add',
				data: category
			}).then(response => {
				callback(response.data);
			}).catch(error => {
				console.log(error);
			});
		},
		updateCategoryAPI(category, callback) {
			HttpService.post({
				url: 'api/forge/categories/update',
				data: category
			}).then(response => {
				callback(response.data);
			}).catch(error => {
				console.log(error);
			});
		},
		deleteCategoryAPI(categoryId, callback) {
			HttpService.post({ url: `api/forge/categories/delete/${categoryId}` }).then(response => {
				callback(response.data);
			}).catch(error => {
				console.log(error);
			});
		},
		updatePointClouds(pointclouds) {
			this.pointclouds = pointclouds;
		},
		onUpdateProjects(projects) {
			this.$store.state.projects = projects;
		},
		onUpdateLevels(levels) {
			this.$store.state.levels = levels;
		}
	},
	computed: {
		viewer: {
			get() {
				return this.$store.state.viewer;
			},
			set(value) {
				this.$store.state.viewer = value;
			}
		},
		forgeService: {
			get() {
				return this.$store.state.forgeService;
			}
		},
		isParentOrigin: function () {
			return this.$store.getters['getParentSiteName']?.includes('origin')
		},
		assetId() {
			return this.$store.state.assetId
		},
		projects() {
			return this.$store.state.projects
		},
		levels() {
			return this.$store.state.levels
		},
		isAdmin() {
			return this.$store.getters['getIsAdminUser']
		},
		categories() {
			return this.$store.state.categories
		},
		forgeSettings() {
			return this.$store.state.forgeSettings
		},
		localSuccessMessage: function () {
			return this.$store.getters['getSuccessMessage'] ?? ''
		},
		isAMIS() {
			return this.$store.state.forgeSettings?.isAMIS;
		},
		isInspectionOn() {
			return this.$store.state.forgeSettings.isInspectionsOn;
		},
		amisToken() {
			return this.$store.getters["GET_AMIS_TOKEN"]
		},
		showPopulateAutomaticTagsPopup() {
			return this.$store.getters['GET_SHOW_POPULATE_AUTOMATIC_TAGS_POPUP']
		},
		createdOn() {
			if (!this.shownModel?.createdOn) return '';

			var date = new Date(this.shownModel.createdOn);

			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var day = date.getDate();
			var hour = date.getHours();
			var minute = date.getMinutes();

			// Add leading zero if value is less than 10
			if (month < 10) {
				month = '0' + month;
			}
			if (day < 10) {
				day = '0' + day;
			}
			if (hour < 10) {
				hour = '0' + hour;
			}
			if (minute < 10) {
				minute = '0' + minute;
			}

			return `${year}-${month}-${day} ${hour}:${minute}`;
		},
	},
	watch: {
		isInspectionOn: {
			handler: function (newValue, oldValue) {
				if (newValue && !this.amisToken) {
					getAMISToken()
					.then(token => {
						this.$store.commit("SET_AMIS_TOKEN", token);
					})
					.catch(error => {
						this.$store.dispatch({ type: "alert_Forge", message: 'Failed to get AMIS token' });
					});
				}
			}
		}
	}
}
</script>

<style>
    :root {
        /* root element */
        --primary-color: #ad5087;
        --light-primary-color: #e1c3d2;
        --dark-primary-color: #78325c;
        --main-font: ArtifaktElement, Helvetica Neue, Segoe UI Semilight, sans-serif;
        --secondry-color: #51A0C4 !important;
        --light-secondry-color: #92bacc !important;
        --dark-secondry-color: #377896 !important;
    }

    #main-admin-container {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .model-row {
        width: calc(100% - 10px);
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px;
        cursor: pointer;
    }

        .model-row:hover {
            background-color: lightgray;
        }

    .model-version-checkbox {
        font-size: 15px;
    }

    .btn-hover-orange {
        font-size: 15px;
        color: gray;
        padding: 6px;
    }

        .btn-hover-orange:hover {
            color: orange;
        }

    .main-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        margin-top: 5px;
        font-size: 14px;
    }

    .right-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: 100%;
        padding: 10px;
    }

    .left-content {
        position: relative;
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        width: 50%;
        overflow-y: auto;
        height: 100%;
    }

    .info-section {
        padding: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
    }

    #admin-forge-viewer {
        width: 100%;
        flex-grow: 1;
    }

    .section-title {
        width: calc(100% - 10px);
        font-size: 18px;
        font-weight: 400;
    }

    .clickable-header {
        cursor: pointer;
        padding: 5px;
        display: flex;
    }

        .clickable-header:hover {
            background-color: #ececec;
        }

    .top-points-above-plan {
        display: flex;
        flex-direction: row;
        height: 30px;
        align-items: center;
        position: absolute;
        top: 0;
        right: 35px;
        z-index: 3;
        padding: 1px;
        margin-top: 2px;
    }

    .collabsable-section {
        border: 1px solid lightgray;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .1), 0 2px 2px 0 rgba(0, 0, 0, 0.07), 0 1px 5px 0 rgba(0, 0, 0, .06);
        margin-top: 10px;
        margin-right: 10px;
        width: calc(100% - 15px);
    }

    .expanded-section {
        width: 100%;
        animation-name: admin-tab-animation;
        animation-duration: .5s;
        position: relative;
    }

    @keyframes admin-tab-animation {
        0% {
            width: 0;
        }

        100% {
            width: 100%;
        }
    }

    .expanded-section div:first-child {
        animation-name: admin-childs-animation;
        animation-duration: 1s;
    }

    @keyframes admin-childs-animation {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .expand-collapse-ico {
        font-size: 15px;
        text-align: right;
    }

    .row-input {
        display: flex;
        padding: 5px;
        align-items: center;
        justify-content: space-between;
    }

    .top-right-btn {
        position: absolute;
        right: 5px;
        top: 5px;
        font-size: 13px;
        cursor: pointer;
        font-weight: 500;
        padding: 3px;
        font-family: cursive;
    }

        .top-right-btn:hover {
            background-color: red;
            color: white !important;
        }


    .upload-section {
        height: 35px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
    }

    .property-wrapper {
        max-width: 300px;
        display: flex;
        column-gap: 5px;
    }

    .property-title {
        font-weight: 700;
        font-size: 14px;
        white-space: nowrap;
    }

    .model-info-section .property-value {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .model-info-section {
        height: fit-content;
        padding: 5px 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
    }

    .model-info {
        display: flex;
        flex-direction: column;
        row-gap: 7px;
    }

    .admin-viewer {
        height: calc(50% - 35px);
        flex-grow: 1;
        width: 100%;
    }

    .admin-btn.disabled {
        background: var(--light-primary-color);
        pointer-events: none;
    }
</style>
